import React from 'react';
import { FiCode } from 'react-icons/fi';

const Footer = () => (
  <footer style={{
    background: 'var(--bg-secondary)',
    borderTop: '1px solid var(--border-color)',
    padding: '40px 0',
  }}>
    <div className="container" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <div style={{
          width: 32, height: 32,
          background: 'var(--gradient-primary)',
          borderRadius: '8px',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <FiCode size={16} color="white" />
        </div>
        <span style={{ fontFamily: 'var(--font-mono)', fontWeight: 700 }}>
          edemaukabi<span style={{ color: 'var(--accent-primary)' }}>.dev</span>
        </span>
      </div>
      <p style={{ color: 'var(--text-muted)', fontSize: '0.88rem', display: 'flex', alignItems: 'center', gap: '6px' }}>
        Built by Edema Ukabi using React & Django Rest Framework
      </p>
      <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>
        &copy; {new Date().getFullYear()} All rights reserved
      </p>
    </div>
  </footer>
);

export default Footer;
